import React from 'react';

interface ProfileButtonProps {
  onClick?: () => void;
  photoURL?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const ProfileButton: React.FC<ProfileButtonProps> = ({ 
  onClick, 
  photoURL, 
  size = 'md',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6 border',
    md: 'w-12 h-12 border-2',
    lg: 'w-16 h-16 border-4'
  };

  return (
    <button 
      className={`rounded-full bg-white shadow-lg overflow-hidden hover:scale-105 transition-transform active:scale-95 border-white inline-block align-middle ${sizeClasses[size]} ${className}`}
      onClick={onClick}
      aria-label="Open Profile"
    >
      <img 
        src={photoURL || 'https://picsum.photos/id/64/100/100'} 
        alt="Profile" 
        className="w-full h-full object-cover" 
      />
    </button>
  );
};
